import MerchantOrTeamBlockedInfo from 'components/merchant-or-team-blocked/MerchantOrTeamBlockedInfo';
import { selectIsActionsBlocked } from 'containers/app/appSlice';
import CreateCommissionRule from 'containers/settings/commission-settings/CreateCommissionRule';
import { useAppSelector } from 'hooks';
import React, { FC } from 'react';

const CreateCommissionRulePage: FC = () => {
  const isActionsBlocked = useAppSelector(selectIsActionsBlocked);

  return isActionsBlocked ? <MerchantOrTeamBlockedInfo title="Create Commission Rule" /> : <CreateCommissionRule />;
};

export default CreateCommissionRulePage;
